module.exports = __webpack_public_path__ + "media/images/hamb-white-8078d4e0928e84c2c0465bff492837ad.svg";